import { all, fork } from "redux-saga/effects";

import dataSourceSaga from "./dataSource/sagas";
import schemaDataSaga from "./schemaSelection/sagas";
import dataTargetSaga from "./dataTarget/sagas";
import taskSaga from "./eventBasedTrigger/sagas";
import jobSaga from "./timeBasedTrigger/sagas";
import metaDataExtractorSaga from "./extractor/metaData/sagas";
import patternsSaga from "./extractor/sagas";
import jobSchedulesSaga from "./jobSchedules/sagas";
import workFlowsSaga from "./workFlows/sagas";
import triggerSaga from "./events/sagas";
import groupsSaga from "./groups/sagas";
import overrideSaga from "./roleOverRide/sagas";
import dataLoaderSaga from "./dataLoader/sagas";
import webhookSaga from "./webhooks/sagas";
import spokeSaga from "./spokes/sagas";
import profileSaga from "./userProfile/sagas"
import subscriptionSaga from "./subscriptions/sagas"
import insituSaga from "./insituExtractor/sagas";
import overrideRequestSaga from "./requestOverride/sagas";



export function* rootSaga() {
    yield all([fork(dataSourceSaga)]);
    yield all([fork(schemaDataSaga)]);
    yield all([fork(overrideSaga)]);
    yield all([fork(spokeSaga)]);
    yield all([fork(dataTargetSaga)]);
    yield all([fork(taskSaga)]);
    yield all([fork(jobSaga)]);
    yield all([fork(profileSaga)]);
    yield all([fork(metaDataExtractorSaga)]);
    yield all([fork(patternsSaga)]);
    yield all([fork(webhookSaga)]);
    yield all([fork(jobSchedulesSaga)]);
    yield all([fork(subscriptionSaga)]);
    yield all([fork(workFlowsSaga)]);
    yield all([fork(triggerSaga)]);
    yield all([fork(dataLoaderSaga)]);
    yield all([fork(groupsSaga)]);
    yield all([fork(insituSaga)]);
    yield all([fork(overrideRequestSaga)]);
}
